// extracted by mini-css-extract-plugin
export default {"wrapper":"JournalInfoContainer_wrapper__egrWe","goal":"JournalInfoContainer_goal__35lR0","wordCount":"JournalInfoContainer_wordCount__GqquO"};